import RichTextView from "./RichTextView";

export default RichTextView